import React from 'react';
import PropTypes from 'prop-types';
import { StepIndicatorContainer, StepCircle } from './styles';

const StepIndicator = ({ currentStep, totalSteps }) => {
  return (
    <StepIndicatorContainer data-panel='panel-level-stepIndicators'>
      {Array.from({ length: totalSteps }).map((_, index) => (
        <StepCircle key={`n°-${index + 1}`} active={index + 1 === currentStep} />
      ))}
    </StepIndicatorContainer>
  );
};

StepIndicator.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired
};

export default StepIndicator;
